import { ProductBuilderMachineContext } from '../types';
import { productPropertySummary } from './productPropertySummary';

type CurtainLineItems = (
  context: ProductBuilderMachineContext,
) => {
  _ROOM: string;
  _BLINDTYPE: string;
  _LENOPTION: string;
  _LINING: string;
  _MOUNTTYPE: string;
  _MATCHITEM: string;
  _PGMCODE: string;
  _REMARK: string;
  _SIZETYPE: string;
  _STACKID: string;
  _STYLE: string;
  _TIEBACK: string;
  _dynamic_product: boolean;
  _WIDTH: string;
  _FULLNESS: string;
  _COLORCODE: string;
  _TRACKCOLOUR: string;
  _SUPPLIER: string;
};

export const getCurtainLineItems: CurtainLineItems = context => {
  const { custom } = context;
  const productSummaryCapture = productPropertySummary(context);
  let style, lining, stackId;

  const currentVariant = context.productWithMeasurements
    ? context.productWithMeasurements.data.find(
        ({ attributes: { freight } }) => freight === context.custom.shipping,
      )
    : null;

  const baseProduct = context.products.filter(product =>
    product.variants.some(
      variant =>
        variant.id ===
        (currentVariant ? currentVariant.attributes.base_variant_id : null),
    ),
  );

  // Check if the product type is Curtain
  const isCurtain = context.products[0]?.type === "Curtain";

  const colourCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('Colour Code'))
        ?.replace('Colour Code: ', '')
    : '';

  const pgmCode = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('PGMCODE'))
        ?.replace('PGMCODE:', '')
    : '';

  const materialType = baseProduct
    ? baseProduct[0].tags
        .find(tag => tag.includes('Material'))
        ?.replace('Material: ', '')
    : '';

  // Only include track colour if track is required (exclude when "No" or undefined)
  const trackColour = (custom!.trackRequire === 'No' || custom!.trackColour === 'No') ? undefined : custom!.trackColour;

  stackId =
    custom.configuration === 'Centre Opening (2 Curtains)'
      ? 'LR'
      : custom.configuration === 'Left Stack (1 Curtain)'
      ? 'L'
      : 'R';

  style =
    custom.pleatType === 'Wave Pleat'
      ? 'DP003'
      : custom.pleatType === 'Double Pleat'
      ? 'DP002'
      : 'DP001';

  lining =
    custom.lining === 'In-between/Dim Out'
      ? 'Translucent'
      : custom.lining === 'Blockout'
      ? 'Blackout'
      : '';

  return {
    _ROOM: `${context.custom.roomName}`,
    _BLINDTYPE:
      custom.configuration === 'Centre Opening (2 Curtains)'
        ? 'pair'
        : 'single',
    _LENOPTION: 'Floor',
    _LINING: lining,
    _MOUNTTYPE:
      custom.fitting === 'Ceiling Mount'
        ? 'IN'
        : custom.fitting === 'Wall Mount'
        ? 'OUT'
        : custom.fitting === 'Face Mount'
        ? 'IN'
        : 'OUT',
    _MATCHITEM: '', // empty
    _PGMCODE: pgmCode ? pgmCode : '', // Fabric material type
    _REMARK: '', // empty
    _SIZETYPE: custom.fitting === 'Face Mount' ? 'WS' : 'MFF',
    _STACKID: stackId,
    _STYLE: style,
    _TIEBACK: 'Y',
    _dynamic_product: true,
    _FULLNESS: '180',
    _WIDTH:
      custom.configuration === 'Centre Opening (2 Curtains)' && currentVariant && !isCurtain
        ? (currentVariant.attributes.width * 2).toString()
        : currentVariant
        ? currentVariant?.attributes.width.toString()
        : '',
    _COLORCODE: colourCode ? colourCode : '',
    _TRACKCOLOUR: trackColour,
    _SUPPLIER: `${baseProduct[0].metafields.supplier}`,
    ...productSummaryCapture,
  };
};
